module.exports = __webpack_public_path__ + "5e78d21bdaf1e9c560ca318e59627c02.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.html
// module id = 2063
// module chunks = 0